import { TableData } from "components/table/table";
import { isCheckBoxDefinition, CheckboxDefinition } from "components/table/columns/CheckColumn";

export class TableModel {

    private model: any[][] = [];
    private pRecordsTotal: number;
    public footer: any;
    // store the applied filter. As the user can modify the filter data we will keep here the really applied filter to be used in actions.
    private appliedFilterModel;


    public getRow(rowindex: number): any[] {
        return this.model[rowindex];
    }

    public getRows(start: number, length: number): any[][] {
        return this.model.slice(start, length);
    }

    public setRow(rowIndex: number, rowData: any[]) {
        this.model[rowIndex] = rowData;
    }

    public addNewRow(rowData: any[]) {
        this.model[this.pRecordsTotal] = rowData;
        this.pRecordsTotal++;
    }

    public setCell(rowindex: number, columnIndex: number, data: any) {
        let newDataModel = data;
        let actualDataModel = this.model[rowindex][columnIndex];
        // Check if is checkbox
        if (isCheckBoxDefinition(actualDataModel)) {
            newDataModel = actualDataModel;
            (newDataModel as CheckboxDefinition).checked = data;
        }
        this.model[rowindex][columnIndex] = newDataModel;
    }

    public empty() {
        this.model.length = 0;
        this.pRecordsTotal = 0;
    }

    public getLastRow(): any[] {
        return this.getRow(this.model.length - 1);
    }

    public getAllRows(): any[][] {
        return this.model;
    }

    get length() {
        return this.model.length;
    }

    public pushRow(newRow: any[]) {
        this.model.push(newRow);
    }

    public setData(data: TableData) {
        this.empty();
        if (data.data != null) {
            this.model.push(...data.data);
        }
        if (data.recordsTotal == null) {
            this.pRecordsTotal = data.data.length;
        } else {
            this.pRecordsTotal = data.recordsTotal;
        }
        this.footer = data.footer;
        this.appliedFilterModel = data.filter;
    }

    public checkExistingKeyInModel(key: string, rowKey) {
        // Warning, this will probably be slow
        for (const line of this.model) {
            if (key === rowKey.key(line)) {
                return true;
            }
        }
        return false;
    }

    get recordsTotal() {
        return this.pRecordsTotal;
    }

    set recordsTotal(recordsTotal: number) {
        this.pRecordsTotal = recordsTotal;
    }

    /**
     * Get te amount of rows than can be checked.
     *
     * It is only useful for client side tables and selection chec columns.
     * @param columnIndex
     */
    public getSelectableRowsCount(columnIndex: number): number {
        return this.model.filter((r) => {
            let y = r[columnIndex];
            //TODO EVO1
            if (isCheckBoxDefinition(y)) {
                let checkbox = y as CheckboxDefinition;
                return checkbox.disabled === false;
            } else {
                return y === true;
            }
        }).length;
    }

    public getColumn(columnIndex: number): any[] {
        return this.model.map((r) => r[columnIndex]);
    }

    public findFirstMissing(start: number, end: number): number {
        for (let i = start; i < end; i++) {
            if (this.model[i] == null) {
                return i;
            }
        }
        return end;
    }

    public findLastMissingLength(start: number, length: number): number {
        for (let i = length - (start - start); i >= 0; i--) {
            if (this.model[start + i - 1] == null) {
                return i;
            }
        }
        return 0;
    }

    public getFilterData() {
        return this.appliedFilterModel ?? {};
    }

    public resetFilterData(currentData: {}) {
        this.appliedFilterModel = JSON.parse(JSON.stringify(currentData));
    }
}
